module.exports = __webpack_public_path__ + "static/img/review-failed.57505234.png";